import type {
  Discount,
  PaymentSchedule,
  ProductPackage,
  QuoteTemplate,
} from '@/pages/sidebar/SettingsPage/types';

export const DEFAULT_PRODUCT_PACKAGES: ProductPackage[] = [
  {
    id: 'pkg-1',
    name: 'Gold Wedding Package',
    description:
      '10 Hours photography\n24 page Wedding Album\n2x Large 40" x 30" Canvases\n20x Small 5" x 7" Prints\n700+ Photos\nHigh and low resolution photos, retouched and ready to print\nOnline slideshow movie\nPre wedding consultation\nNo copyright protection. No watermarks.',
    price: 4995,
  },
  {
    id: 'pkg-2',
    name: 'Silver Wedding Package',
    description: '8 Hours photography\nWedding album\nDigital gallery delivery',
    price: 3800,
  },
];

export const DEFAULT_DISCOUNTS: Discount[] = [
  { id: 'disc-1', name: 'Early Bird Discount', amount: 10, type: '%' },
  { id: 'disc-2', name: 'Gift Voucher', amount: 200, type: '$' },
];

export const DEFAULT_PAYMENT_SCHEDULES: PaymentSchedule[] = [
  {
    id: 'ps-1',
    name: '25% Deposit + 75% due 14 days before Main Event',
    payments: [],
  },
];

export interface QuoteTemplateWithRef extends QuoteTemplate {
  templateRef: string;
}

export const DEFAULT_QUOTE_TEMPLATES: QuoteTemplateWithRef[] = [];
